import { jsx as e, jsxs as r } from "react/jsx-runtime";

import { memo as t } from "react";

import a from "../RadioGroup/index.js";

import s from "../../utils/classNames/index.js";

const i = "rounded-[12px]", o = t => (a, o, l, n, m) => {
    const {prefix: d, suffix: p, ...c} = m || {};
    return r("label", {
        ...c,
        htmlFor: a,
        className: s("group relative overflow-hidden", i, o ? "bg-neutral-200" : "cursor-pointer hover:bg-neutral-100", c?.className),
        children: [ d, r("div", {
            className: s("p-s gap-s flex justify-between text-neutral-600", "rm" === t ? "items-center" : "items-start"),
            children: [ l, e("input", {
                ...n,
                disabled: o,
                id: a,
                className: s("peer flex-none", n.className)
            }), e("div", {
                "aria-hidden": "true",
                className: s("pointer-events-none absolute inset-0 z-10 border-2 border-neutral-300", o ? "" : "peer-checked:border-primary-600 group-hover:border-primary-500", i)
            }) ]
        }), p ]
    });
}, l = t((({className: r, skipDefaultStyling: t = !0, controlPlacement: i = "rm", ...l}) => e(a, {
    ...l,
    skipDefaultStyling: t,
    className: s("gap-s", r),
    renderOption: o(i)
})));

export { l as default };
//# sourceMappingURL=index.js.map
